import React from 'react';

import TireChangeStore from '../tire-change-store';
import moment from 'moment';
import Countdown from './Countdown';

const InputField = ({ label, name, type='text', onChange, value=''}) => {
    return (
        <div className="input-field">
            <label>{label}</label>
            <input type={type} name={name} onChange={e => onChange(e)} value={value} />
        </div>
    );
}


const BankButtons = ({bankData}) => {
    return (
        <div className="payment">
            <h2>Valitse maksutapa</h2>
            <div className="options">
                { bankData.banks.providers.map(p => (
                    <div className="option">
                        <form action={p.url} method="POST">
                            {p.parameters.map(({ name, value }) => (
                                <input type="hidden" name={name} value={value} />
                            ))}
                            <img src={p.icon} alt={p.name} />
                            <button className="btn">{p.name}</button>
                        </form>
                    </div>
                ))}
            </div>
        </div>
    );
};

class Customer extends React.Component {
    constructor(props) {
        super(props);
        const storeData = TireChangeStore.getAll();
        this.state = {
            first_name: window.customer_info ? window.customer_info['first_name'] : '',
            last_name: window.customer_info ? window.customer_info['last_name'] : '',
            phone: window.customer_info ? window.customer_info['mobile'] : '',
            email: window.customer_info ? window.customer_info['email'] : '',
            address: window.customer_info ? window.customer_info['address'] : '',
            postal_code: window.customer_info ? window.customer_info['postal_code'] : '',
            postal_office: window.customer_info ? window.customer_info['post_office'] : '',
            licence_number: storeData.licenseNumber,
            selectedService: storeData.selectedService,
            timeIsUp: storeData.timeIsUp,
            wantsHotel: storeData.hotel,
            bankData: null,
            customerInfoStarted: moment(),
            paymentBegun: false,
        }
        this.update = this.update.bind(this);
    }
    update() {
        const storeData = TireChangeStore.getAll();
        this.setState({
            selectedService: storeData.selectedService,
            timeIsUp: storeData.timeIsUp,
        });
    }
    componentDidMount() {
        TireChangeStore.addChangeListener(this.update);
    }
    componentWillUnmount() {
        TireChangeStore.removeChangeListener(this.update);
    }
    getCustomerData() {
        const {
            first_name, last_name, phone, email,
            address, postal_code, postal_office
        } = this.state;
        return {
            first_name: first_name,
            last_name: last_name,
            mobile: phone,
            email: email,
            shipping_address: address,
            shipping_postal_code: postal_code,
            shipping_post_office: postal_office,
        };
    }
    createOrderAndPay() {
        this.setState({ paymentBegun: true });

        // Validate & save customer info
        $.post('/ajax-customer/', this.getCustomerData(), resp => {
            const { selectedService } = this.state,
              payload = {
                product: selectedService,
                count: 1,
              };

            // Add selected service to the shopping cart
            $.post('/_ajax/shopping-cart/webshop_work', payload, () => {
                const confirmData = {
                    licence_number: this.state.licence_number.toUpperCase(),
                    comment: this.state.wantsHotel ? 'Asiakas kiinnostunut jättämään renkaat hotelliin' : '',
                    confirm: true,
                    deny_newsletter: false,
                };

                // Get payment buttons
                $.post('/ajax-confirm/', confirmData, res => {
                    window.scrollTo(0, 0);
                    this.setState({bankData: res});
                });
            });
        });
    }
    confirmDisabled() {
        const {
            first_name, last_name, phone, email,
            address, postal_code, postal_office
        } = this.state;

        if ([first_name, last_name, phone, email,
            address, postal_code, postal_office].includes('')) {

            return true;
        }

        return false;
    }
    render() {
        if (this.state.bankData) {
            return <BankButtons bankData={this.state.bankData} />;
        }

        if (this.state.timeIsUp) {
            return (
                <div className="time-is-up">
                    <h3>Voi ei!</h3>
                    <p>Valitettavasti valitsemasi aika ehti vanhentumaan. Klikkamalla alta pääset aloittamaan varauksen uudelleen.</p>
                    <br/>
                    <a className="btn" href="/ajanvaraus-allelaitto/">Aloita alusta</a>
                </div>
            );
        }

        const confirmDisabled = this.confirmDisabled();
        return (
            <div>
                <Countdown startTime={this.state.customerInfoStarted} length={10} />
                <section className="customer">
                    <h3>Yhteystiedot</h3>
                    <span></span>
                    <InputField name="first_name" label="Etunimi" value={this.state.first_name} onChange={({ target }) => this.setState({first_name: target.value})} />
                    <InputField name="last_name" label="Sukunimi" value={this.state.last_name} onChange={({ target }) => this.setState({last_name: target.value})} />
                    <InputField name="phone" label="Puhelinnumero" value={this.state.phone} type="tel" onChange={({ target }) => this.setState({phone: target.value})} />
                    <InputField name="email" label="Sähköposti" value={this.state.email} type="email" onChange={({ target }) => this.setState({email: target.value})} />
                    <h3>Osoitetiedot</h3>
                    <span></span>
                    <InputField name="address" label="Katuosoite" value={this.state.address} onChange={({ target }) => this.setState({address: target.value})} />
                    <InputField name="postal_code" label="Postinumero" value={this.state.postal_code} onChange={({ target }) => this.setState({postal_code: target.value})} />
                    <InputField name="postal_office" label="Postitoimipaikka" value={this.state.postal_office} onChange={({ target }) => this.setState({postal_office: target.value})} />
                    <span></span>
                    <span></span>
                    <span></span>
                    <div>
                        {confirmDisabled && <i>Täytä kaikki kentät</i>}
                        <br/>
                        <button disabled={confirmDisabled || this.state.paymentBegun} onClick={() => this.createOrderAndPay()} className="btn btn-confirm">Siirry maksamaan</button>
                    </div>
                </section>
            </div>
        );
    }
}

export default Customer;


/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/tire-change/components/Customer.js
 **/